(function () {
  'use strict';

  if (window.__cromaProductCtaSystemInitialized) return;
  window.__cromaProductCtaSystemInitialized = true;

  var CTA_SELECTOR = 'button, a, [role="button"], input[type="button"], input[type="submit"]';
  var availabilityButtonObserver = null;
  var observedAvailabilityButton = null;

  function normalizeText(value) {
    var text = String(value || '').toLowerCase();
    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return text.replace(/\s+/g, ' ').trim();
  }

  function getLabel(element) {
    return normalizeText(
      element.value ||
      element.textContent ||
      element.getAttribute('aria-label') ||
      element.getAttribute('title') ||
      ''
    );
  }

  function isBackInStock(label) {
    return label.indexOf('avisame cuando haya stock') !== -1 ||
      label.indexOf('avisame cuando este disponible') !== -1 ||
      label.indexOf('notificarme cuando haya stock') !== -1 ||
      label.indexOf('notify me when available') !== -1 ||
      label.indexOf('notify me when back in stock') !== -1;
  }

  function expandAppWrappers(element) {
    var boundary = element.closest ? element.closest('.product-block-list__item--info') : null;
    var parent = element.parentElement;
    var depth = 0;

    while (parent && parent !== boundary && depth < 3) {
      if (parent.matches && parent.matches('.product-form, .card__section, .product-form__payment-container')) break;
      parent.classList.add('croma-back-in-stock-wrap');
      parent = parent.parentElement;
      depth += 1;
    }
  }

  function markCandidate(element) {
    if (!element || !element.classList) return;
    if (isBackInStock(getLabel(element))) {
      element.classList.add('croma-back-in-stock-cta');
      expandAppWrappers(element);
    }
  }

  function getAvailabilityButton() {
    return document.querySelector('.template-product .product-form__add-button');
  }

  function getAvailabilityInquiry() {
    return document.querySelector('.template-product [data-croma-availability-inquiry]');
  }

  function buttonIsUnavailable(button) {
    if (!button) return false;
    return button.disabled ||
      button.classList.contains('button--disabled') ||
      button.getAttribute('aria-disabled') === 'true';
  }

  function getVariantStockMap() {
    var node = document.querySelector('[data-croma-variant-stock-map]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariantId(button) {
    var form = button && button.closest ? button.closest('form') : null;
    if (!form) return '';

    var input = form.querySelector('[name="id"]');
    return input ? String(input.value || '') : '';
  }

  function selectedVariantHasStock(button) {
    var map = getVariantStockMap();
    var variantId = getSelectedVariantId(button);

    if (map && variantId && Object.prototype.hasOwnProperty.call(map, variantId)) {
      return map[variantId] === true;
    }

    return !buttonIsUnavailable(button);
  }

  function updateInquiryHref(inquiry) {
    if (!inquiry) return;

    var email = inquiry.getAttribute('data-croma-availability-email') || '';
    var productTitle = inquiry.getAttribute('data-croma-product-title') || document.title || '';
    var subject = 'Consulta disponibilidad: ' + productTitle;
    var body = 'Hola, quisiera consultar disponibilidad de ' + productTitle + '. ' + window.location.href;

    inquiry.setAttribute(
      'href',
      'mailto:' + email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body)
    );
  }

  function syncStickyAvailability(button, inquiry, unavailable) {
    var stickyButton = document.querySelector('[data-croma-sticky-button]');
    if (!stickyButton) return;

    if (unavailable && inquiry) {
      stickyButton.textContent = String(inquiry.textContent || '').replace(/\s+/g, ' ').trim();
      stickyButton.disabled = false;
      stickyButton.classList.add('croma-availability-mode');
      stickyButton.setAttribute('data-croma-availability-mode', 'true');
      return;
    }

    stickyButton.classList.remove('croma-availability-mode');
    stickyButton.removeAttribute('data-croma-availability-mode');

    if (button) {
      stickyButton.textContent = String(button.textContent || '').replace(/\s+/g, ' ').trim();
      stickyButton.disabled = buttonIsUnavailable(button);
    }
  }

  function bindAvailabilityButton(button) {
    if (!button || observedAvailabilityButton === button) return;

    if (availabilityButtonObserver) {
      availabilityButtonObserver.disconnect();
    }

    observedAvailabilityButton = button;
    availabilityButtonObserver = new MutationObserver(function () {
      syncAvailabilityCta();
    });

    availabilityButtonObserver.observe(button, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function syncAvailabilityCta() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    var button = getAvailabilityButton();
    var inquiry = getAvailabilityInquiry();

    if (!button || !inquiry) return;

    bindAvailabilityButton(button);
    updateInquiryHref(inquiry);

    // Shopify's active add-to-cart button is the source of truth for sellability.
    var unavailable = buttonIsUnavailable(button);

    var form = button.closest ? button.closest('form') : null;
    if (form) {
      form.classList.toggle('croma-no-real-stock', unavailable);
    }

    button.classList.toggle('croma-availability-source-hidden', unavailable);

    if (unavailable) {
      button.setAttribute('aria-hidden', 'true');
    } else {
      button.removeAttribute('aria-hidden');
    }

    inquiry.hidden = !unavailable;
    inquiry.classList.toggle('croma-availability-inquiry--hidden', !unavailable);

    if (unavailable) {
      inquiry.removeAttribute('aria-hidden');
    } else {
      inquiry.setAttribute('aria-hidden', 'true');
    }

    var applyStickyState = function () {
      syncStickyAvailability(button, inquiry, unavailable);
    };

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(applyStickyState);
    } else {
      applyStickyState();
    }
  }

  function handleStickyAvailabilityClick(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('[data-croma-sticky-button][data-croma-availability-mode="true"]')
      : null;

    if (!target) return;

    var inquiry = getAvailabilityInquiry();
    if (!inquiry || inquiry.hidden) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    inquiry.click();
  }

  function scan(root) {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    if (root && root.matches && root.matches(CTA_SELECTOR)) markCandidate(root);

    if (root && root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(CTA_SELECTOR), markCandidate);
    }

    syncAvailabilityCta();
  }

  function start() {
    document.addEventListener('click', handleStickyAvailabilityClick, true);

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest('.product-form')) return;

      window.setTimeout(syncAvailabilityCta, 0);
      window.setTimeout(syncAvailabilityCta, 80);
    });

    scan(document);

    if (typeof MutationObserver !== 'undefined' && document.body) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'characterData') {
            scan(mutation.target.parentElement);
            return;
          }

          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });

        syncAvailabilityCta();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    window.setTimeout(function () { scan(document); }, 250);
    window.setTimeout(function () { scan(document); }, 750);
    window.setTimeout(function () { scan(document); }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
